import { memo } from "react";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";

import CrmSetupConfigurationOptionsPanel from "../CrmSetupConfigurationOptionsPanel";
import type { UseCrmSetupConfigurationResult } from "../../hooks/useCrmSetupConfiguration";

/**
 * Passo do stepper: mesma UI que o modal «Ativar plano de mensagens» (`CrmSetupConfigurationOptionsPanel`).
 */
interface CrmSetupConfigurationStepProps {
  /**
   * A instância do hook deve vir de fora (page/stepper), para evitar estado duplicado
   * e manter o botão "Próximo" coerente com a seleção Fluxmed/Meta.
   */
  configuration: UseCrmSetupConfigurationResult;
}

const CrmSetupConfigurationStep = memo(
  ({ configuration }: CrmSetupConfigurationStepProps) => {
    if (configuration.isLoadingConfiguration) {
      return (
        <Stack alignItems="center" justifyContent="center" sx={{ py: 5 }}>
          <CircularProgress size={24} />
        </Stack>
      );
    }

    return <CrmSetupConfigurationOptionsPanel {...configuration} />;
  },
);

CrmSetupConfigurationStep.displayName = "CrmSetupConfigurationStep";

export default CrmSetupConfigurationStep;
